module.exports = __webpack_public_path__ + "img/picto-tel.bfaac15d.svg";